export default __webpack_public_path__ + "static/media/yuduroboticsLogo.69007dc2.svg";